<template>
    <div class="page-wrapper">
        <NavBar class="style1" />
        <div class="content-wrapper">
            <PageTitle pageTitle="Pricing Plan" />
            <PricingComp />
        </div>
        <FooterComp />
    </div>
</template>

<script>
import NavBar from '../Layouts/NavBar'
import PageTitle from '../Common/PageTitle'
import PricingComp from '../Pricing/PricingComp'
import FooterComp from '../Layouts/FooterComp'

export default {
    name: 'PricingPage',
    components: {
        NavBar,
        PageTitle,
        PricingComp,
        FooterComp,
    }
}
</script>